var React = require('react');

function Caret02 (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.1","fillRule":"evenodd","clipRule":"evenodd","d":"M1.50259 151.924L22.8548 188.907L204.865 173.199L183.513 136.216L48.7911 147.843L126.221 36.9835L104.869 0.000448042L0.260435 149.772L1.50281 151.924L1.50259 151.924Z","fill":"#9DA4AA"}));
}

Caret02.defaultProps = {"width":"205","height":"189","viewBox":"0 0 205 189","fill":"none"};

module.exports = Caret02;

Caret02.default = Caret02;
